<div class="flex flex-row h-[24px] gap-1 w-[50%] pl-3">
    @if (hasNormalVersion || (count > 0)) {
        <div [ngClass]="{'text-red-500' : !hasNormalVersion}">{{ count }}</div>
        <div class="text-faded-20">|</div>
        <div class="w-6 h-6 flex justify-center">
            <button class="w-full h-full" [disabled]="processing" (click)="adjustNormalCount(1)">
                +
            </button>
        </div>
        <div class="w-6 h-6 flex justify-center">
            <svg>
                <image xlink:href="https://s3.amazonaws.com/images.pondertcg.com/icon/card-standard.svg" width="24" height="24" class="filter-icon-almost-white"/>
            </svg>
        </div>
        <div class="w-6 h-6 flex justify-center">
            <button class="w-full h-full" [disabled]="processing" (click)="adjustNormalCount(-1)">
                -
            </button>
        </div>
    }
</div>
<div class="flex flex-row h-[24px] gap-2 w-[50%] justify-end pr-3">
    @if (hasSpecialVersion || (specialCount > 0)) {
        <div class="w-6 h-6 flex justify-center">
            <button class="w-full h-full" [disabled]="processing" (click)="adjustSpecialCount(1)">
                +
            </button>
        </div>
        <div class="w-6 h-6 flex justify-center">
            <svg>
                <image xlink:href="https://s3.amazonaws.com/images.pondertcg.com/icon/card-foil.svg" width="24" height="24" class="filter-icon-almost-white"/>
            </svg>
        </div>
        <div class="w-6 h-6 flex justify-center">
            <button class="w-full h-full"  [disabled]="processing" (click)="adjustSpecialCount(-1)">
                -
            </button>
        </div>
        <div class="text-faded-20">|</div>
        <div [ngClass]="{'text-red-500' : !hasSpecialVersion}">{{ specialCount }}</div>
    }
</div>